import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import AboutView from "@/components/cl/views/AboutView";

export const Route = createFileRoute("/about")({
  head: () => pageHead("/about"),
  component: AboutView,
});
